export default __webpack_public_path__ + "static/media/not-found.69323a56.png";